import { request } from "@/interface/helper";

const str = "communityMessage";

export const communityMessage = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/message/list" }),
    add: data => request({ data, method: "post", url: "/community/message/add" }),
    detail: data => request({ data, method: "post", url: "/community/message/detail" }),
    edit: data => request({ data, method: "post", url: "/community/message/modify" })
  }
};
